import { useDispatch} from "react-redux";
import React from "react";
import styled from "styled-components";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import {postStake} from "../../../stake/actions/stakeAction";
import {loadOneAxis} from "../../../axis/one-axis/oneAxisAction";
import ExitButton from "../../../buttons/ExitButton";
import {FormFormik, InputTextFormik} from "../../../inputs/InputStyle";
import SendFormButton from "../../../buttons/SendFormButton";

const StakeFormForCoach = ({ axisId, content, close}) => {

    const dispatch = useDispatch();

    const handleSubmit = async (data) => {
        await dispatch(postStake(data));
        await dispatch(loadOneAxis(axisId));
        close();
    };

    const StakeSchema = Yup.object().shape({
        name: Yup.string()
            .min(2, "Le nom de l'enjeu est trop court")
            .max(255, "Le nom de l'enjeu est trop long")
            .required("Le nom de l'enjeu est obligatoire"),
    });

    const displayModal = () => {
        return (
            <Modal>
                <Formik
                    enableReinitialize
                    initialValues={{
                        name: content,
                        axisId: axisId,
                    }}
                    validationSchema={StakeSchema}
                    onSubmit={handleSubmit}
                >
                    {({ isValid, isSubmitting, values, setFieldValue }) => (
                        <>
                            <Form>
                                <div>
                                    <label htmlFor=" name"> Nom de l'enjeu :</label>
                                    <InputTextFormik
                                        name={"name"}
                                        type={"text"}
                                        placeholder={"Écrire le nom de l'enjeu"}
                                    />
                                    <ErrorMessage
                                        name="name"
                                        render={(msg) => (
                                            <div>
                                                <p className="error-text"> {msg} </p>
                                            </div>
                                        )}
                                    />
                                </div>

                                <SendFormButton
                                    actionName={"Ajouter"}
                                    state={isValid && !isSubmitting}
                                />
                            </Form>
                        </>
                    )}
                </Formik>
            </Modal>
        );
    };

    return displayModal();
};

const Modal = styled.div`
  width: 100%;
  gap: 1rem;
  height: fit-content;
`;

const Form = styled(FormFormik)`
  gap: 1.5rem;
`;
const FirstSection = styled.div`
  display: flex;
  flex-direction: row;

  button {
    display: flex;
    align-items: flex-start;
    height: 100%;
  }
`;

export default StakeFormForCoach;
